import axios from 'axios';
import { getToken } from './utils/cookieHandler/token';
import { API_GATEWAY_URI } from './consts';

// Add token interceptor
axios.interceptors.request.use(
  function (config) {
    config.baseURL = API_GATEWAY_URI;
    config.metadata = { startTime: new Date() };
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axios;
